import React, { useEffect, useState } from 'react';
import { ThermometerIcon, HumidityIcon, WindIcon } from '../icons';

import { SyncOutlined } from '@ant-design/icons';

const Weather = () => {
  const [weather, setWeather] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const MPS_TO_KPH_CONVERSION_FACTOR = 3.6;
  useEffect(() => {
    const fetchWeather = async (lat, lon) => {
      const apiKey = process.env.NEXT_PUBLIC_OPENWEATHER_API_KEY;
      if (!apiKey) {
        setError('API key not found');
        return;
      }
      const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        setWeather(data);
      } catch (err) {
        setError('Error getting weather');
      }
    };

    const getLocationAndWeather = () => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            fetchWeather(latitude, longitude);
          },
          async (error) => {
            try {
              const response = await fetch('https://ipapi.co/json/');
              const locationData = await response.json();
              fetchWeather(locationData.latitude, locationData.longitude);
            } catch (err) {
              setError('Could not get location');
            }
          },
          { timeout: 10000, maximumAge: 0, enableHighAccuracy: true }
        );
      } else {
        setError('Geolocation not supported in this browser');
      }
    };

    getLocationAndWeather();
  }, []);

  if (error)
    return (
      <div className="flex h-[160px] w-[250px] justify-center rounded-[10px] border border-primary-light align-middle text-primary">
        Error: {error}
      </div>
    );
  if (!weather)
    return (
      <div className="flex h-[160px] w-[250px] justify-center rounded-[10px] border border-primary align-middle">
        <SyncOutlined style={{ fontSize: '50px' }} className="text-primary" spin />
      </div>
    );

  return (
    <div className="flex h-[160px] w-[250px] flex-col justify-center rounded-[10px] bg-sky-600 pl-[18px] text-white">
      <p className="text-[17px] font-bold">{new Date().toDateString()}</p>
      <div className="flex gap-[10px]">
        <div className="iconWeather">
          <img className="h-[85px]" src={`http://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`} alt="" />
        </div>
        <div className="flex flex-col gap-1 pt-[3px]">
          <div className="flex gap-1 align-middle">
            <ThermometerIcon />
            <p>{weather.main.temp}°C</p>
          </div>
          <div className="flex gap-1 align-middle">
            <HumidityIcon />
            <p>{weather.main.humidity}%</p>
          </div>
          <div className="flex gap-1 align-middle">
            <WindIcon />
            <p>{(weather.wind.speed * MPS_TO_KPH_CONVERSION_FACTOR).toFixed(2)} km/h</p>
          </div>
        </div>
      </div>
      <div>
        <p className="text-[15px] font-bold">
          {weather.name}, {weather.sys.country}
        </p>
      </div>
    </div>
  );
};

export default Weather;
